import { Landing } from "@/features/landing/ui/landing";
import { I18nProvider } from "@/features/i18n/components/I18nProvider";
import { env } from "@/env";
import { LocaleRedirect } from "@/components/ui/LocaleRedirect";
import "@/styles/fonts-nunito-sans.css";

export default Page;

function Page() {
  const locale = env.VITE_DEFAULT_LOCALE || "en";

  return (
    <I18nProvider locale={locale}>
      <LocaleRedirect currentLocale={locale}>
        <Landing />
      </LocaleRedirect>
    </I18nProvider>
  );
}
